/* Wellness Vision v8 add-on: puts the "Crear mi proyecto" section where the sauna builder was.
   The builder markup stays in the page (hidden) because wv7-home.js reads its fields. */
(function () {
  'use strict';

  var root = document.getElementById('wv-home');
  var project = document.querySelector('[data-wv-project]');
  var builder = root && root.querySelector('.sauna-builder');
  if (!root || !project || !builder) return;

  builder.parentNode.insertBefore(project, builder);
  builder.hidden = true;
  builder.setAttribute('aria-hidden', 'true');
  if (builder.id === 'configurador-sauna') {
    builder.removeAttribute('id');
    project.id = 'configurador-sauna';
  }
  project.hidden = false;

  var en = window.WV_LANG === 'en';
  root.querySelectorAll('a[href="#configurador-sauna"]').forEach(function (a) {
    if (a.getAttribute('data-wv-i18n-en') !== 'Custom saunas') return;
    a.setAttribute('data-wv-i18n-en', 'Start my project');
    a.dataset.wvI18nEs = 'Crear mi proyecto';
    a.textContent = en ? 'Start my project' : 'Crear mi proyecto';
  });
  // Moved in after the first language pass; translate now, before motion splits the headings.
  if (window.WV_I18N) window.WV_I18N.applyNative(project, window.WV_LANG);

  document.documentElement.classList.add('wv-project-ready');
})();
